import React, { useEffect, useRef, useState } from 'react';
import { FaBackward, FaForward, FaPause, FaPlay } from 'react-icons/fa';

import './MusicModal.css';

const MusicModal = ({ isMusicOpen, setIsMusicOpen, playlist = [] }) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);
    const [currentTrackIndex, setCurrentTrackIndex] = useState(0);

    const currentTrack = playlist[currentTrackIndex];

    useEffect(() => {
        const audio = audioRef.current;

        if (isMusicOpen && audio && currentTrack) {
            audio.load();
        }

        return () => {
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
        };
    }, [isMusicOpen, currentTrack]);

    useEffect(() => {
        const audio = audioRef.current;

        if (audio) {
            audio.load();
            setIsPlaying(true);
        }
    }, [currentTrack]);

    const onClose = () => {
        setIsMusicOpen(false);
        setCurrentTrackIndex(0);
    };

    const handleNext = () => {
        if (currentTrackIndex < playlist.length - 1) {
            setCurrentTrackIndex(prev => prev + 1);
        }
    };

    const handlePrev = () => {
        if (currentTrackIndex > 0) {
            setCurrentTrackIndex(prev => prev - 1);
        }
    };

    if (!isMusicOpen || playlist.length === 0) return null;

    const getMimeType = (filename) => {
        const ext = filename.split('.').pop().toLowerCase();
        if (ext === 'mp3') return 'audio/mp3';
        if (ext === 'wav') return 'audio/wav';
        if (ext === 'wma') return 'audio/x-ms-wma';
        return 'audio/mpeg';
    };

    const togglePlayPause = () => {
        if (!audioRef.current) return;

        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }

        setIsPlaying(!isPlaying);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="music-container">
                    {currentTrack.coverUrl && (
                        <div className="music-disk-container">
                            <img
                                src={currentTrack.coverUrl}
                                alt="Capa do disco"
                                className={`music-disk ${isPlaying ? 'spin' : ''}`}
                            />
                        </div>
                    )}
                    <h3 className="music-title">{currentTrack.name}</h3>
                    <audio
                        ref={audioRef}
                        controls
                        autoPlay
                        onEnded={handleNext}
                        style={{ width: '100%' }}
                    >
                        <source
                            src={currentTrack.url}
                            type={getMimeType(currentTrack.name)}
                        />
                        Seu navegador não suporta o elemento de áudio.
                    </audio>

                    <div className="music-controls">
                        <button onClick={handlePrev} disabled={currentTrackIndex === 0} title="Anterior">
                            <FaBackward />
                        </button>

                        <button onClick={togglePlayPause} title={isPlaying ? "Pausar" : "Tocar"}>
                            {isPlaying ? <FaPause /> : <FaPlay />}
                        </button>

                        <button onClick={handleNext} disabled={currentTrackIndex === playlist.length - 1} title="Próxima">
                            <FaForward />
                        </button>
                    </div>

                    <button className="close-button" onClick={onClose}>
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MusicModal;
